import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Validators, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import {ToasterModule, ToasterService, Toast, ToasterConfig} from 'angular5-toaster';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-response-modal2',
  templateUrl: './response-modal2.component.html',
  styleUrls: ['./response-modal2.component.scss'],
  providers: []
})
export class ResponseModal2Component implements OnInit {

  titulo = '';
  mensaje1 = '';
  mensaje2 = '';
  mensaje3 = '';
  closeResult: string;

  public toasterconfig: ToasterConfig =
  new ToasterConfig({timeout: 500});
  constructor(
    private translate: TranslateService,
    public activeModal: NgbActiveModal,
    private toasterService: ToasterService,
    private modalService: NgbModal
  ) {
   
  }

  ngOnInit() {
    this.noBack();
    this.titulo = this.titulo; 
    this.mensaje1 = this.mensaje1;
    this.mensaje2 = this.mensaje2;
    this.mensaje3 = this.mensaje3;
  }

  noBack() {
    history.pushState(null, null, location.href);
      window.onpopstate = function () {
          history.go(1);
      };
  }

  closeModal(resp) {
    this.activeModal.close(resp);
  }

  
}






// WEBPACK FOOTER //
// ./src/app/components/response-modal2/response-modal2.component.ts